import { CurveConfig } from '@gong/curve-math';

function pct(bps: bigint): string {
  const whole = bps / 100n;
  const frac = bps % 100n;
  if (frac === 0n) {
    return `${whole}%`;
  }
  return `${whole}.${frac.toString().padStart(2, '0')}%`;
}

/** Человекочитаемые доли для карточки токена (снимок запуска). */
export function formatFeeSplitLine(config: CurveConfig): string {
  const c = config.feeSplit;
  const r = config.routerSplit;
  const h = config.harvestSplit;
  return `Кривая ${pct(c.channelBps)}/${pct(c.protocolBps)}/${pct(c.referrerBps)} · роутер ${pct(r.channelBps)}/${pct(r.protocolBps)}/${pct(r.referrerBps)} · harvest ${pct(h.channelBps)}/${pct(h.protocolBps)}`;
}
